"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _helpers = require("@/helpers");
var _underLoading = require("../helpers/under-loading");
var _mutationTypes = require("../mutation-types");
var _users = _interopRequireDefault(require("@/services/users.service"));
var _businessunitUser = _interopRequireDefault(require("@/services/businessunitUser.service"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var state = {
  listAllUsers: []
};
var mutations = _defineProperty({}, _mutationTypes.SET_USERS_LIST, function (mutationState, payload) {
  mutationState.listAllUsers = payload;
});
var getters = {
  listAllUsers: function listAllUsers(state) {
    return state.listAllUsers;
  }
};
var actions = {
  fetchAllUsers: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref, payload) {
      var commit, _yield$UsersService$f, data, dataItems, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            commit = _ref.commit;
            _context.p = 1;
            _context.n = 2;
            return _users.default.fetchAll();
          case 2:
            _yield$UsersService$f = _context.v;
            data = _yield$UsersService$f.data;
            dataItems = Array.isArray(data) ? data : [data];
            commit(_mutationTypes.SET_USERS_LIST, dataItems);
            return _context.a(2, dataItems);
          case 3:
            _context.p = 3;
            _t = _context.v;
            _helpers.errorResponseHelper.display(_t);
            return _context.a(2, false);
        }
      }, _callee, null, [[1, 3]]);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }()),
  fetchUserDetail: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_ref3, idUser) {
      var commit, _yield$UsersService$f2, data, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            commit = _ref3.commit;
            _context2.p = 1;
            _context2.n = 2;
            return _users.default.fetchItem(idUser);
          case 2:
            _yield$UsersService$f2 = _context2.v;
            data = _yield$UsersService$f2.data;
            return _context2.a(2, data);
          case 3:
            _context2.p = 3;
            _t2 = _context2.v;
            _helpers.errorResponseHelper.display(_t2);
            return _context2.a(2, false);
        }
      }, _callee2, null, [[1, 3]]);
    }));
    return function (_x3, _x4) {
      return _ref4.apply(this, arguments);
    };
  }()),
  createUser: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(_ref5, payload) {
      var commit, _yield$UsersService$c, data, _t3;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            commit = _ref5.commit;
            _context3.p = 1;
            _context3.n = 2;
            return _users.default.create(payload);
          case 2:
            _yield$UsersService$c = _context3.v;
            data = _yield$UsersService$c.data;
            _helpers.messageHelper.success();
            return _context3.a(2, data);
          case 3:
            _context3.p = 3;
            _t3 = _context3.v;
            _helpers.errorResponseHelper.display(_t3);
            return _context3.a(2, false);
        }
      }, _callee3, null, [[1, 3]]);
    }));
    return function (_x5, _x6) {
      return _ref6.apply(this, arguments);
    };
  }()),
  updateUser: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(_ref7, payload) {
      var commit, idUser, _yield$UsersService$u, data, _t4;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            commit = _ref7.commit;
            _context4.p = 1;
            idUser = payload.idUser;
            delete payload.idUser;
            delete payload.PersonId;
            _context4.n = 2;
            return _users.default.update(payload, idUser);
          case 2:
            _yield$UsersService$u = _context4.v;
            data = _yield$UsersService$u.data;
            _helpers.messageHelper.success();
            return _context4.a(2, data);
          case 3:
            _context4.p = 3;
            _t4 = _context4.v;
            console.log(_t4);
            _helpers.errorResponseHelper.display(_t4);
            return _context4.a(2, false);
        }
      }, _callee4, null, [[1, 3]]);
    }));
    return function (_x7, _x8) {
      return _ref8.apply(this, arguments);
    };
  }()),
  fetchEndUsers: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref0 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(_ref9) {
      var commit, _yield$UsersService$f3, data, _t5;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            commit = _ref9.commit;
            _context5.p = 1;
            _context5.n = 2;
            return _users.default.fetchEndUsers();
          case 2:
            _yield$UsersService$f3 = _context5.v;
            data = _yield$UsersService$f3.data;
            return _context5.a(2, data);
          case 3:
            _context5.p = 3;
            _t5 = _context5.v;
            _helpers.errorResponseHelper.display(_t5);
            return _context5.a(2, false);
        }
      }, _callee5, null, [[1, 3]]);
    }));
    return function (_x9) {
      return _ref0.apply(this, arguments);
    };
  }()),
  fetchAllOrganizationPersons: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(_ref1, idUser) {
      var commit, _yield$UsersService$f4, data, payload, _t6;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.p = _context6.n) {
          case 0:
            commit = _ref1.commit;
            _context6.p = 1;
            _context6.n = 2;
            return _users.default.fetchAllOrganizationPersons(idUser);
          case 2:
            _yield$UsersService$f4 = _context6.v;
            data = _yield$UsersService$f4.data;
            payload = Array.isArray(data) ? data : [data];
            return _context6.a(2, payload);
          case 3:
            _context6.p = 3;
            _t6 = _context6.v;
            return _context6.a(2, false);
        }
      }, _callee6, null, [[1, 3]]);
    }));
    return function (_x0, _x1) {
      return _ref10.apply(this, arguments);
    };
  }()),
  createOrganizationPersons: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(_ref11, payload) {
      var commit, _t7;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.p = _context7.n) {
          case 0:
            commit = _ref11.commit;
            _context7.p = 1;
            _context7.n = 2;
            return _users.default.createOrganizationPersons(payload);
          case 2:
            _helpers.messageHelper.success();
            return _context7.a(2, true);
          case 3:
            _context7.p = 3;
            _t7 = _context7.v;
            _helpers.errorResponseHelper.display(_t7);
            return _context7.a(2, false);
        }
      }, _callee7, null, [[1, 3]]);
    }));
    return function (_x10, _x11) {
      return _ref12.apply(this, arguments);
    };
  }()),
  deleteOrganizationPersons: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref14 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(_ref13, payload) {
      var commit, _t8;
      return _regenerator().w(function (_context8) {
        while (1) switch (_context8.p = _context8.n) {
          case 0:
            commit = _ref13.commit;
            _context8.p = 1;
            _context8.n = 2;
            return _users.default.deleteOrganizationPersons(payload);
          case 2:
            _helpers.messageHelper.success();
            return _context8.a(2, true);
          case 3:
            _context8.p = 3;
            _t8 = _context8.v;
            _helpers.errorResponseHelper.display(_t8);
            return _context8.a(2, false);
        }
      }, _callee8, null, [[1, 3]]);
    }));
    return function (_x12, _x13) {
      return _ref14.apply(this, arguments);
    };
  }()),
  createBusinessUnitPersons: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref16 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(_ref15, payload) {
      var commit, _t9;
      return _regenerator().w(function (_context9) {
        while (1) switch (_context9.p = _context9.n) {
          case 0:
            commit = _ref15.commit;
            _context9.p = 1;
            _context9.n = 2;
            return _businessunitUser.default.createBusinessUnitPersons(payload);
          case 2:
            _helpers.messageHelper.success();
            return _context9.a(2, true);
          case 3:
            _context9.p = 3;
            _t9 = _context9.v;
            _helpers.errorResponseHelper.display(_t9);
            return _context9.a(2, false);
        }
      }, _callee9, null, [[1, 3]]);
    }));
    return function (_x14, _x15) {
      return _ref16.apply(this, arguments);
    };
  }()),
  fetchAllBusinessUnitPersons: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref18 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(_ref17, idUser) {
      var commit, _yield$BusinessunitUs, data, _t0;
      return _regenerator().w(function (_context0) {
        while (1) switch (_context0.p = _context0.n) {
          case 0:
            commit = _ref17.commit;
            _context0.p = 1;
            _context0.n = 2;
            return _businessunitUser.default.fetchAllBusinessUnitPersons(idUser);
          case 2:
            _yield$BusinessunitUs = _context0.v;
            data = _yield$BusinessunitUs.data;
            return _context0.a(2, data);
          case 3:
            _context0.p = 3;
            _t0 = _context0.v;
            return _context0.a(2, false);
        }
      }, _callee0, null, [[1, 3]]);
    }));
    return function (_x16, _x17) {
      return _ref18.apply(this, arguments);
    };
  }()),
  deleteBusinessUnitPersons: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref20 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(_ref19, idBusinessUnit) {
      var commit, _t1;
      return _regenerator().w(function (_context1) {
        while (1) switch (_context1.p = _context1.n) {
          case 0:
            commit = _ref19.commit;
            _context1.p = 1;
            _context1.n = 2;
            return _businessunitUser.default.deleteBusinessUnitPersons(idBusinessUnit);
          case 2:
            return _context1.a(2, true);
          case 3:
            _context1.p = 3;
            _t1 = _context1.v;
            console.log(_t1);
            _helpers.errorResponseHelper.display(_t1);
            return _context1.a(2, false);
        }
      }, _callee1, null, [[1, 3]]);
    }));
    return function (_x18, _x19) {
      return _ref20.apply(this, arguments);
    };
  }()),
  updatePassUser: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref22 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(_ref21, payload) {
      var commit, idUser, _t10;
      return _regenerator().w(function (_context10) {
        while (1) switch (_context10.p = _context10.n) {
          case 0:
            commit = _ref21.commit;
            _context10.p = 1;
            idUser = payload.id;
            delete payload.ConfirmUserPassword;
            delete payload.id;
            _context10.n = 2;
            return _users.default.updatePass(payload, idUser);
          case 2:
            _helpers.messageHelper.success();
            return _context10.a(2, true);
          case 3:
            _context10.p = 3;
            _t10 = _context10.v;
            console.log(_t10);
            _helpers.errorResponseHelper.display(_t10);
            return _context10.a(2, false);
        }
      }, _callee10, null, [[1, 3]]);
    }));
    return function (_x20, _x21) {
      return _ref22.apply(this, arguments);
    };
  }()),
  sendCredentialUser: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref24 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(_ref23, payload) {
      var commit, _t11;
      return _regenerator().w(function (_context11) {
        while (1) switch (_context11.p = _context11.n) {
          case 0:
            commit = _ref23.commit;
            _context11.p = 1;
            _context11.n = 2;
            return _users.default.sendCredentialUserMail(payload);
          case 2:
            _helpers.messageHelper.success();
            return _context11.a(2, true);
          case 3:
            _context11.p = 3;
            _t11 = _context11.v;
            console.log(_t11);
            _helpers.errorResponseHelper.display(_t11);
            return _context11.a(2, false);
        }
      }, _callee11, null, [[1, 3]]);
    }));
    return function (_x22, _x23) {
      return _ref24.apply(this, arguments);
    };
  }()),
  fetchAllAccessUser: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref26 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(_ref25, payload) {
      var commit, _yield$UsersService$f5, data, _t12;
      return _regenerator().w(function (_context12) {
        while (1) switch (_context12.p = _context12.n) {
          case 0:
            commit = _ref25.commit;
            _context12.p = 1;
            _context12.n = 2;
            return _users.default.fetchAllAccessUser(payload);
          case 2:
            _yield$UsersService$f5 = _context12.v;
            data = _yield$UsersService$f5.data;
            return _context12.a(2, data);
          case 3:
            _context12.p = 3;
            _t12 = _context12.v;
            return _context12.a(2, false);
        }
      }, _callee12, null, [[1, 3]]);
    }));
    return function (_x24, _x25) {
      return _ref26.apply(this, arguments);
    };
  }())
};
var _default = exports.default = {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};